export const percentageNumberFormatter = (value) => {
  return value ? parseFloat(value.toFixed(2)) : value;
};
